<section id="about">
  <div class="container">
      <div class="row">
          <div class="col-12">
              <h1>Investing for Catholics - Art Gallery</h1>
          </div>
      </div>
  </div>
</section>



<app-photo-album [photos]="photos" albumTitle="Art Gallery"></app-photo-album>